<kt-portlet class="knostos-grid">
  <kt-portlet-header
    title="Patient History"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource?.loading$"
  >
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mat-table-wrapper">
      <mat-table
        class="lmat-elevation-z8"
        [dataSource]="dataSource"
        matSort
        matSortActive="version"
        matSortDirection="desc"
        matSortDisableClear
        style="max-height: 600px"
      >
        <ng-container matColumnDef="version">
          <mat-header-cell *matHeaderCellDef class="mat-column">Version</mat-header-cell>
          <mat-cell
            *matCellDef="let log"
            class="mat-column clickable"
            (click)="openPatientModReviewDialog(log.version, log.rev_type)"
          >
            {{ log.version }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="action_type">
          <mat-header-cell *matHeaderCellDef class="mat-column">Action Type</mat-header-cell>
          <mat-cell *matCellDef="let log" class="mat-column"> {{ log.rev_type }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="modified_at">
          <mat-header-cell *matHeaderCellDef class="mat-column">Modified At</mat-header-cell>
          <mat-cell *matCellDef="let log" class="mat-column">
            {{ getModTime(log.rev_timestamp) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="modified_by">
          <mat-header-cell *matHeaderCellDef class="mat-column">Modified By</mat-header-cell>
          <mat-cell *matCellDef="let log" class="mat-column"> {{ log.username }} </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <div class="mat-table__message" *ngIf="noRecords">{{ 'TABLE.NO_RECORDS' | translate }}</div>
      <div class="mat-table__message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'TABLE.PLAESE_WAIT' | translate }}
      </div>
    </div>

    <!-- start: BOTTOM -->
    <div class="mat-table__bottom" hidden>
      <mat-spinner [diameter]="20" *ngIf="dataSource?.loading$ | async"></mat-spinner>
    </div>
    <!-- end: BOTTOM -->
  </kt-portlet-body>
  <!-- end::Body -->
</kt-portlet>
